import React from 'react';
import './Scorecard.scss';
import ScoreCardIcon from '../../assets/images/newScoreCardWordIcon.png'

const Scorecard = () => {
  return (
    <div className="scorecard">
      {/* Sales Section */}
      <div className="main-card">
        {/* <h1>Hello</h1> */}
        {/* <img src={ScoreCardIcon} alt="" /> */}
        <div className="image-container">
          <img src={ScoreCardIcon} style={{
            width: '180px',
            marginBottom: '20px'
          }} alt="" />
        </div>
        <div className="" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'start',
          padding: '10px 20px',
          backgroundColor: '#f5f5f5',
          borderRadius: '8px',
          marginBottom: '20px',
        }}>
          <div className="sales-header">
            <h2>Sales</h2>
          </div>

          {/* 3 Columns for Daily / WTD / PTD */}
          <div className="sales-stats">
            <div className="stat-column">
              <h4>.</h4>
              <h5>Net Sales</h5>
              <h5>Avg Check.</h5>
              <h5>Avg Dig Check.</h5>
            </div>
            <div className="stat-column">
              <h4>Daily</h4>
              <p>$5,013</p>
              <p>$13.26</p>
              <p>$12.73</p>
            </div>
            <div className="stat-column">
              <h4>WTD</h4>
              <p>$27,816</p>
              <p>$14.69</p>
              <p>$14.74</p>
            </div>
            <div className="stat-column">
              <h4>PTD</h4>
              <p>$123,456</p>
              <p>$12.73</p>
              <p>$13.23</p>
            </div>
          </div>

          {/* V.S Last Year */}
          <div className="vs-last-year">
            <h4>V.S. Last Year</h4>
            <div>Net Sales: <span className="green">+12.2%</span></div>
            <div>Customers: <span className="green">+2.0%</span></div>
            <div>Tickets: <span className="red">-2.0%</span></div>
          </div>
        </div>

        {/* 3 Small Sub Cards */}
        <div className="sales-bottom">
          <div className="sub-card">
            <h4>Source</h4>
            <div>Instore: 62.0%</div>
            <div>Online: 20.0%</div>
            <div>3rd Par: 18.0%</div>
          </div>
          <div className="sub-card">
            <h4>Order Type</h4>
            <div>Dine In: 62.0%</div>
            <div>Takeout: 20.0%</div>
            <div>Drive Thru: 18.0%</div>
          </div>
          <div className="sub-card">
            <h4>Sales Category</h4>
            <div>Entree: 62.0%</div>
            <div>Drinks: 20.0%</div>
            <div>N/A Bev: 18.0%</div>
          </div>
        </div>
      </div>

      {/* Labor, Service, Customer Section */}
      <div className="lower-section">
        <div className="sub-card">
          <h4>Labor</h4>
          <div>% Sales: 21.0%</div>
          <div>SPLH: $50</div>
          <div>EPLH: 27</div>
          <div>OT/Prem: $53</div>
        </div>

        <div className="sub-card">
          <h4>Service</h4>
          <div>KDS (min): 6.7</div>
          <div>In Store: 7.6</div>
          <div>Digital: 12.3</div>
          <div>Window: 3.3</div>
        </div>

        <div className="sub-card">
          <h4>Customer</h4>
          <div>Sentiment: 81.0%</div>
          <div>Google: 4.3</div>
          <div>Yelp: 2.7</div>
          <div>Guest Conn.: 8.6</div>
        </div>
      </div>
    </div>
  );
};

export default Scorecard;
